import React, { useCallback } from "react";
import { NavLink } from "react-router-dom";
import { PermissionProps } from "../../Model/Permission";
import PermissionUtil from "../../Utility/PermissionUtil";
import { usePermission } from "../Common/PermissionProvider";

interface Props extends PermissionProps {
  onClick?: () => void;
  to: string;
  style?: React.CSSProperties;
  icon: React.ReactNode;
  label: string;
  disabled?: boolean;
}
const NavSubItem = ({
  onClick = () => {},
  to,
  icon,
  label,
  style = {},
  permissions,
  componentId,
  disabled = false,
}: Props) => {
  const componentCanRead = PermissionUtil.canReadComponent(
    permissions,
    componentId
  );

  // check use Permission and have permissions or discard permissions
  const showComponent = permissions ? componentCanRead && permissions : true;

  const handleIsActive = useCallback(
    (match: any, location: any) => {
      if ((location.pathname as string).includes(to)) return true;
      else return false;
    },
    [to]
  );

  return (
    <>
      {showComponent && (
        <NavLink
          style={{
            color: "white",
            opacity: disabled ? "0.25" : "1",
            cursor: disabled ? "default": "pointer",
            ...style,
          }}
          onClick={() => onClick()}
          to={disabled ? "#" : to}
          isActive={handleIsActive}
          activeClassName="sidebar-submenu-active"
        >
          <div className="item-container">
            <div className="submenu-icon">{icon}</div>
            <div className="submenu-text">{label} </div>
          </div>
        </NavLink>
      )}
    </>
  );
};

export const NavSubItemWithPermission = usePermission(NavSubItem);
export default NavSubItem;
